import React, { useEffect, useState } from "react";
import { CellType } from "utils/enums";
import { IProductTemplateAttribute } from "components/dashboard/product-template-table/utils/interfaces";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { T } from "services/lang/LanguageService";
import { useGetProductTemplateConfig } from "api/api-hooks/product-templates-hooks";
import { InputText } from "primereact/inputtext";
import { IProductTemplateDropdownChangeEvent } from "../product-template/ProductTemplateDropdown";

interface IHiddenColumnsDropdownProps {
  value?: Array<string>;
  onChange?: (e: MultiSelectChangeEvent) => void;
  selectedTemplate?: IProductTemplateDropdownChangeEvent;
  className?: string;
  id?: string;
  disabled?: boolean;
  showClear?: boolean;
  setProductTemplateCreationDate?: (date: Date) => void;
  setSelections?: (selections: Attribute[]) => void;
  allowedTypes?: CellType[];
}

export interface Attribute {
  label: string;
  type: CellType;
  value: string;
}

export default function ProductTemplateColumnsDropdown(props: IHiddenColumnsDropdownProps) {
  const [allSelections, setAllSelections] = useState<Attribute[]>([]);
  const query = useGetProductTemplateConfig(
    props.selectedTemplate?.refName!,
    `${props.selectedTemplate?.value}`,
    [],
    [],
    {
      enabled: !!props.selectedTemplate?.refName && !Number.isNaN(props.selectedTemplate?.value),
    }
  );

  useEffect(() => {
    if (query.data) {
      let selections = query.data.data?.attributes.map((element: IProductTemplateAttribute) => ({
        label: element.displayName,
        value: element.referenceName,
        type: element.type,
      }));

      if (props.allowedTypes) {
        selections = selections?.filter(selection => props.allowedTypes!.includes(selection.type));
      }

      if (props.setProductTemplateCreationDate && query.data.dateCreated) {
        props.setProductTemplateCreationDate(new Date(query.data.dateCreated));
      }

      setAllSelections(selections ?? []);
      props.setSelections?.(selections ?? []);
    }
  }, [query.data, props.allowedTypes]);

  const onChange = (e: MultiSelectChangeEvent) => {
    props.onChange?.(e);
  };

  if (!props.selectedTemplate?.refName || Number.isNaN(props.selectedTemplate?.value)) {
    return (
      <InputText
        id={props.id}
        placeholder={T("message.product-template-is-not-selected")}
        disabled
      />
    );
  }
  return (
    <>
      {query.error && (
        <InputText
          id={props.id}
          placeholder={T("error.product-template-selection-error")}
          disabled
        />
      )}
      {query.isLoading && !query.error && (
        <InputText id={props.id} placeholder={T("message.product-templates-loading")} disabled />
      )}
      {query.isSuccess && (
        <MultiSelect
          placeholder={T("action.select-columns")}
          id={props.id}
          className={props.className}
          value={props.value || []}
          options={allSelections}
          onChange={onChange}
          showClear={props.showClear}
          disabled={props.disabled}
          maxSelectedLabels={1}
        />
      )}
    </>
  );
}
